<template>
  <div>
    <v-container class="content-container">
      <v-layout row wrap class="section">
        <v-flex xs12 md8>
          <v-text-field v-model="username" label="Username" required></v-text-field>
        </v-flex>
        <v-flex xs12 md8>
          <v-text-field type="password" v-model="password" label="Password" required></v-text-field>
        </v-flex>
        <v-flex xs12 md8>
          <div @click="submit">Continue</div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Head from "@/components/Page/Head";
import Heading from "@/components/Page/Heading";
import Back from "../modules/Back";

export default {
  name: "Page",
  components: { Head, Heading },
  data: function() {
    return {
      username: "",
      password: ""
    };
  },
  methods: {
    submit() {}
  },
  async created() {
    // this.assignments = await Back.assignments();
    // console.log("assignments", this.assignments);
  }
};
</script>

<style scoped>
.section-divider {
  width: 100%;
  height: 40px;
}
</style>